module.exports = {
  siteMetadata: {
    title: 'Christian Wolter',
    description: 'Homepage: Christian Wolter',
    url: 'http://www.christian-wolter.com',
    author: 'Christian Wolter',
    twitter: '3xmo',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/src/pages`,
        name: 'pages',
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          {
            resolve: 'gatsby-remark-images',
            options: {
              maxWidth: 750,
              linkImagesToOriginal: false,
              wrapperStyle: 'margin-bottom: 1.0725rem;',
            },
          },
          {
            resolve: 'gatsby-remark-responsive-iframe',
            options: {
              wrapperStyle: 'margin-bottom: 1.0725rem',
            },
          },
          'gatsby-remark-prismjs',
          'gatsby-remark-copy-linked-files',
          'gatsby-remark-smartypants',
        ],
      },
    },
    'gatsby-transformer-sharp',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
/*
    {

      resolve: 'gatsby-plugin-google-analytics',
      options: {
        trackingId: ``,
      },
    },
*/
    'gatsby-plugin-offline',
    'gatsby-plugin-react-helmet',
  ],
}



// WEBPACK FOOTER //
// ./gatsby-config.js